export default __webpack_public_path__ + "static/media/371.2ea21f8b.png";